<!--
 * @Description:批量分发
 * @Author: JDY
 * @Date: 2021-04-25 14:20:09
 * @LastEditTime: 2021-06-28 16:32:55
 * @LastEditors: JDY
-->
<template>
  <a-form :form="form">

    <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-radio-group
        name="state"
        v-decorator="[
          'state',
          {
            rules: [{ required: true, message: '是否废弃' }],
            initialValue: 2
          }
        ]"
      >
        <a-radio :value="1">
          作废
        </a-radio>
        <a-radio :value="2">
          取消作废
        </a-radio>
      </a-radio-group>
    </a-form-item>

  </a-form>
</template>

<script>
import { requestPut } from '@/api/api'

export default {
    name: 'ModelForm',
    props: {
        tid: {
            type: Array,
            default: () => {
                return []
            },
            required: true
        }
    },
    data () {
        return {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            form: this.$form.createForm(this)
        }
    },
    mounted () {

    },
    methods: {
        /**
         * 点击确定按钮提交表单
         * @param
         * @jdy
         */
        onOk () {
            const that = this
            const {
                form: { validateFields }
            } = that
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    values.id = that.$props.tid
                    if (!errors) {
                        requestPut('/coupons/invaild', values)
                            .then(res => {
                                that.$notification.success({
                                    message: res.msg
                                })
                                resolve(true) // 关闭弹出层
                            })
                            .catch(err => console.log(err))
                    }
                })
            })
        },
        /**
         * 去掉按钮关闭弹窗
         * @param
         * @jdy
         */
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>
